module.exports = __webpack_public_path__ + "static/media/noun-spa-2528450-808080.703af96e.svg";